import { Component, HostBinding } from '@angular/core';

import { getEffectiveExternalReviewUrl } from '../../../../../utils/url.validators';
import { BookingActionBaseComponent } from './booking-action.base-component';

@Component({
  template: '',
  standalone: false,
})
export abstract class LeaveFeedbackActionBaseComponent extends BookingActionBaseComponent {
  /**
   * AM-4364 Variant B — adds the `lh-enter-from-success` host class when this modal was
   * launched from the green validate-booking success surface (the post-validation rating
   * strip set `enterFromSuccess` on its action; the timeline propagated it to this instance).
   * The class drives the green→white "wash" entry animation in
   * `leave-feedback-action.component.scss` and the fullscreen review. Crucially this is gated
   * on the launching action, NOT the flow — so editing a review from the timeline (which
   * keeps the modal chrome) does not get the wash/fullscreen and stays compact.
   */
  @HostBinding('class.lh-enter-from-success')
  get isEnterFromSuccess(): boolean {
    return this.enterFromSuccess;
  }

  /**
   * AM-4364 — adds the `lh-feedback-fullscreen` host class for always-rated review entry
   * points (rating strip + edit review), driving the full-bleed `.modal-body` so `lh-review`
   * can fill the viewport. Set by the timeline from the launching action's `fullscreenReview`.
   */
  @HostBinding('class.lh-feedback-fullscreen')
  get isFullscreenReview(): boolean {
    return this.fullscreen;
  }

  get shopName(): string {
    if (!this.shop) {
      return null;
    }
    return this.shop.name;
  }

  /**
   * Compose-ready review URL passed down into the inner `<lh-review>` component. Prefers
   * the GBP-sourced reviewUrl over the manually-entered top-level externalReviewUrl. See
   * {@link getEffectiveExternalReviewUrl} for the precedence rule.
   */
  get effectiveExternalReviewUrl(): string {
    return getEffectiveExternalReviewUrl(this.shop);
  }

  async onBaseInit() {
    this.shop = await this.shopsService.getShop(this.booking.shopId);
  }
}
